import { AD_MANAGEMENT } from "../types/actions";

const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case AD_MANAGEMENT.GET_ADS_LIST:
			return { ...state, ads_list: action.payload };
		case AD_MANAGEMENT.ADD_NEW_AD_SUCCESS:
			return {
				...state,
				ads_list: {
					...state.ads_list,
					results: [...state.ads_list.results, action.payload],
					count: state.ads_list.count + 1
				}
			};
		case AD_MANAGEMENT.UPDATE_AD_SUCCESS:
			// eslint-disable-next-line no-case-declarations
			const index = state.ads_list.results.findIndex((item) => item.id === action.payload.id);
			return {
				...state,
				ads_list: {
					...state.ads_list,
					results: [
						...state.ads_list.results.slice(0, index),
						action.payload,
						...state.ads_list.results.slice(index + 1)
					]
				}
			};
		default:
			return state;
	}
};
